import { render, staticRenderFns } from "./page2wordpress.vue?vue&type=template&id=ab595c68&"
import script from "./page2wordpress.vue?vue&type=script&lang=js&"
export * from "./page2wordpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports